import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import { shouldUseReferralProgramV2 } from '~/growthbook';
import { routes } from '~/routes';
import { hideMessage, showMessage } from '../actions';
import { CloseCircleIcon } from '../images/icons';
import { useUserSelector } from './useUserSelector';

const REFERRAL_QUERY_PARAM = 'referral';
const SHORT_LINK_QUERY_PARAM = 'branch_url';

export const useReferralHandler = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useUserSelector();
  const { search } = useLocation();

  useEffect(() => {
    const qs = new URLSearchParams(search);
    const referralId = qs.get(REFERRAL_QUERY_PARAM);
    const shortLink = qs.get(SHORT_LINK_QUERY_PARAM);

    if (user && referralId) {
      if (shouldUseReferralProgramV2()) {
        navigate(routes.referral, { state: { shortLink } });
        localStorage.removeItem('referralId');
        return;
      }
      dispatch(
        showMessage({
          title: 'Account Already Exists',
          message:
            'It looks like you already have a GoTu account or already started creating one. If you have not completed your first shift, you may enter the referral link from Account > Enter Referral Link.',
          isError: true,
          popupProps: {
            Icon: () => <CloseCircleIcon size={80} />,
            rightButtonText: 'Close',
            rightButtonAction: () => {
              dispatch(hideMessage());
              // remove referral from query params
              const url = new URL(window.location.href);
              url.searchParams.delete(REFERRAL_QUERY_PARAM);
              window.history.replaceState({}, '', url);
            },
          },
        }),
      );
      return;
    }

    if (referralId) {
      localStorage.setItem('referralId', referralId);
    }
  }, [user]);

  const clearReferral = () => {
    localStorage.removeItem('referralId');
  };

  const getReferral = () => localStorage.getItem('referralId') || '';

  const handleReferral = (code) => {
    if (user) {
      return;
    }

    localStorage.setItem('referralId', code);
  };

  return { clearReferral, getReferral, handleReferral };
};
